import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { useFrozenSupplierTabBreadcrumbs } from "Helpers/useFrozenSupplierBreadcrumbs";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Vendor  } from "assets/SideBarIcons/vendor.svg";
import SupplierTabs from "./SupplierTabs";
import { Box } from "@mui/material";
import PurchaseInvoiceListing from "pages/Inventory/PurchaseInvoiceListing";
export default function SupplierBills() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const params = useParams();
    const breadcrumbItems = useFrozenSupplierTabBreadcrumbs("bills");
    return (<>
        <ComponentHeaderTwo
            showBtn={true}
            showSaveBtn={false}
            onClick={() => navigate('/suppliers')}
            onSubmit={() => {}}
            heading={t('vendor')}
            icon={<Vendor height={28} width={28} />}
            btnText={"back"}
            btnType={"back"}
            showCreateBtn={false}
            breadcrumbItems={breadcrumbItems}
        />
        <Box className={`flex`}>
            <SupplierTabs params={params} selectedIndex={2} />
            <Box className='mt-[10px] w-[100%]'>
                <PurchaseInvoiceListing supplierId={+(params as any)?.id} />
            </Box>
        </Box>
    </>)
}
